module.exports = __webpack_public_path__ + "static/media/event_default.93392ff7.jpg";